import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { User } from "@tabipla/shared/domain";

// Persisted atoms (saved to localStorage)
export const userAtom = atomWithStorage<User | null>("mekke-auth-user", null);

// Non-persisted atoms (reset on page refresh)
export const isLoadingAtom = atom(true);

// Flag to track if initial auth check has completed
export const isAuthCheckedAtom = atom(false);

// Derived atoms (computed from other atoms)
// Only consider authenticated if auth check has completed AND user exists
export const isAuthenticatedAtom = atom((get) => {
  const isAuthChecked = get(isAuthCheckedAtom);
  const user = get(userAtom);
  // If auth check hasn't completed yet, don't consider authenticated
  if (!isAuthChecked) return false;
  return user !== null;
});
